<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <v-layout wrap>
          <v-flex xs6 style="padding: 10px">
            <v-layout wrap>
              <v-flex xs6 style="padding-right: 10px">
                <i-datepicker
                    value=""
                    label="Nhập ngày muốn kiểm tra"
                    clearable
                    @clearText="clearFromDate"
                    @change="onChangeFromDate"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="id"
            search-url="/getAccountPartPoint/searchAll?sortField=status,id&"
            create-url="/getAccountPartPoint/save"
            delete-url="/getAccountPartPoint/delete"
            form-type="intable"
            custom-create-new
            custom-edit-item
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="true"
            :accept-edit="false"
            :accept-create="false"
            :acceptExport="6"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/topic/TopicCreate";
import {statusMHBL} from "@/constants/areaConstants";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Thông tin account log học",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      programName: null,
      programId: null,
      ageId: null,
      ageName: null,
      levelNumber: null,
      levelId: null,
      fromDate: null,
      toDate: null,
      weekTotal: null,
      hiddenFields: {
        typeId: "0",
        fromDate: null,
        toDate: null,
      },
      fields: [
        {
          value: 'accountIdStr',
          text: 'account_id',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'profileId',
          text: 'profile_id',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 60px;",
        },
        {
          value: 'phoneNumber',
          text: 'phoneNumber',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'createdAt',
          text: 'created_at',
          sortable: false,
          search: false,
          dateFormat: 'dd/MM/yyyy hh:mm',
          headerStyle: "text-align:center; width: 80px;",
        },
        {
          value: 'birthYear',
          text: 'birthYear',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'partName',
          text: 'partName',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
       /* {
          type: "select",
          name: "birthYear",
          value: 'birthYear',
          text: 'Năm sinh',
          sortable: false,
          search: true,
          headerStyle: "text-align:center ;width: 80px;",
          itemText: "status",
          itemValue: "value",
          items: [
            {value: 2022, status: '2022'},
            {value: 2021, status: '2021'},
            {value: 2020, status: '2020'},
            {value: 2019, status: '2019'},
            {value: 2018, status: '2018'},
            {value: 2017, status: '2017'},
            {value: 2016, status: '2016'},
            {value: 2015, status: '2015'},
            {value: 2014, status: '2014'},
          ],
        },
        {
          type: "select",
          name: "partName",
          value: 'partName',
          text: 'Lesson 1 Part',
          sortable: false,
          search: true,
          headerStyle: "text-align:center ;width: 80px;",
          itemText: "status",
          itemValue: "value",
          items: [
            {value: 1, status: 'Part 1'},
            {value: 2, status: 'Part 2'},
            {value: 3, status: 'Part 3'},
          ],
        },*/
      ],
    };
  },

  created() {
  },


  methods: {

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },

    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    clearFromDate() {
      this.hiddenFields.fromDate = new Date();
    },
    clearToDate() {
      this.hiddenFields.toDate = new Date();
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/tracking/view/' + item.userName,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
